import { useState } from "react";
import Form from "../../../../Partials/Forms/Form"
import EmailInput from "../../../../Partials/Forms/FormInputs/EmailInput/EmailInput"
import FormSubmitButton from "../../../../Partials/Forms/FormSubmitButton/FormSubmitButton"

function ForgotPasswordForm({ handleSubmit, email, setEmail }) {
    const [isEmailValid, setIsEmailValid] = useState(false);
    return (
        <Form
            onSubmit={handleSubmit}
        >
            <EmailInput
                label='Email'
                value={email}
                placeholder='Please Enter your Email'
                setState={setEmail}
                setIsValid={setIsEmailValid}
            />
            <FormSubmitButton text='Continue' />

        </Form>
    )
}

export default ForgotPasswordForm